import { render, staticRenderFns } from "./UserConfig.vue?vue&type=template&id=6d183746"
import script from "./UserConfig.vue?vue&type=script&lang=js"
export * from "./UserConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d183746')) {
      api.createRecord('6d183746', component.options)
    } else {
      api.reload('6d183746', component.options)
    }
    module.hot.accept("./UserConfig.vue?vue&type=template&id=6d183746", function () {
      api.rerender('6d183746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/UserConfig.vue"
export default component.exports